export default {
  dialog: {
    mainDiv:
      'buy-now-container bg-white mx-auto p-15 pb-10 sm:w-11/12 md:w-70p relative top-50pm buy-now-lite',
    title:
      'pt-20 pl-20 pb-20 text-20 text-left leading-normal font-BebasNeueBold text-black-lighter ',
    closeButton: 'absolute right-0 buy-now-close',
    closeSpan: 'closespan',
    linkContainer:
      'buy-now-margin sm:w-5/12 md:w-28p flex sm:my-7 sm:mx-7 md:my-10 md:mx-10',
    content: 'flex flex-wrap content-start ',
    link: 'w-full flex justify-center  event_buy_now_eretailer_exit',
  },
  buyNowBtn: {
    buyNow: 'btn btn-secondary event_buy_now event_buy_now_choose_retailer',
  },
  listCardBtn: 'try-now-btn z-1 bg-white',
  buyNowLiteLogo: 'buy-now-lite-pantene-logo',
  buyNowLitevarientContainer: 'varientContainer',
  buyNowLiteVarientWrapper: 'VarientWrapper',
  buyNowLiteVarientsize: 'varientsize',
  buyNowLiteRetailerWrapper: 'retailerWrapper',
  buyNowLiteproductName: 'productName',
  buyNowLiteStoreVisit:
    'font-sans-roma text-base pb-20 text-center w-1/2 mx-auto mt-25',
  buyNowLiteLogoTwo: 'buy-now-lite-logo',
};
